var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg16 = function Svg16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9 2.583a.75.75 0 0 1 .75.75v9.333a.75.75 0 0 1-1.5 0V8.75H3.083v3.916a.75.75 0 0 1-1.5 0V3.333a.75.75 0 0 1 1.5 0V7.25H8.25V3.333a.75.75 0 0 1 .75-.75M12.333 6.583c1.15 0 2.084.933 2.084 2.083v.143c0 .63-.268 1.233-.737 1.655l-1.614 1.452h1.601l.076.004a.751.751 0 0 1 0 1.492l-.076.004H11a.75.75 0 0 1-.75-.75v-.395c.002-.204.019-.453.122-.684l.058-.111c.144-.25.362-.433.51-.565l1.737-1.562.053-.055a.73.73 0 0 0 .187-.485v-.143a.584.584 0 0 0-1.167 0v.267a.75.75 0 0 1-1.5 0v-.267c0-1.15.933-2.083 2.083-2.083"
  })));
};
export default Svg16;